import React, { useState } from 'react';
import { Slot } from 'components/dashboard/dashboard/MonitoringBoard';
import slot from '../components/slot/Slot';

export type ContextType = {
  sidebarOpen: boolean;
  updateSidebarOpen: (data: boolean) => void;
  selectedOption: string;
  updateOptionSelection: (data: string) => void;
  slots: Slot[];
  updateSlots: (data: Slot[]) => void;
  selectedSlot: number;
  updateSelectedSlot: (id: number) => void;
  sessions: any[];
  setSessions: React.Dispatch<any>;
  proctors: any[];
  setProctors: React.Dispatch<any>;
  selectedProctors: number[];
  setSelectedProctors: React.Dispatch<number[]>;
};

type Props = React.PropsWithChildren;

export const DashboardContext = React.createContext<ContextType | null>(null);

export const DashboardProvider: React.FC<Props> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [selectedOption, setSelectedOption] = useState<string>('dashboard');
  const [selectedSlot, setSelectedSlot] = React.useState<number | null>(null);
  const [slots, setSlots] = useState<Slot[]>([]);
  const [sessions, setSessions] = React.useState<any>([]);
  const [proctors, setProctors] = React.useState<any[]>([]);
  const [selectedProctors, setSelectedProctors] = React.useState<number[]>([]);

  const updateSidebarOpen = (data: boolean) => {
    setSidebarOpen(data);
  };
  const updateOptionSelection = (data: string) => {
    setSelectedOption(data);
  };
  const updateSlots = (data: Slot[]) => {
    setSlots(data);
  };
  const updateSelectedSlot = (id: number) => {
    setSelectedSlot(id);
  };
  return (
    <DashboardContext.Provider
      value={{
        sidebarOpen,
        updateSidebarOpen,
        selectedOption,
        updateOptionSelection,
        slots,
        updateSlots,
        selectedSlot,
        updateSelectedSlot,
        sessions,
        setSessions,
        proctors,
        setProctors,
        selectedProctors,
        setSelectedProctors,
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
export default DashboardProvider;
